import { usePermissions } from 'react-admin';

export default function useIsAdmin(explicitPermissions?: any): boolean {
    const { permissions } = usePermissions();

    const perms =
        (Array.isArray(explicitPermissions) && explicitPermissions) ||
        (Array.isArray(permissions) && permissions) ||
        [];

    return perms.includes('admin');
}
